import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Grid, TextField, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useState } from 'react';
import './PrTable.css';
import { IoClose } from 'react-icons/io5';
import SnackBar from '../General/SnackBar';
import { useEffect } from 'react';
import { GetAllDevice, PostPurchaseRequest } from 'API/PurchaseRequest/api';
import ConfirmationDialog from './ConfirmModal';

export default function CreateRequestDialog(props) {
  const [Data, setData] = useState({
    device_name: 'select',
    brand_name: 'select',
    modal_number: 'select',
    bank_name: 'select',
    remarks: ''
  });

  const [AlertOpen, setAlertOpen] = useState(false);
  const [AlertMessage, setAlertMessage] = useState(null);
  const [AlertType, setAlertType] = useState('success');
  const [IsLoading, setIsLoading] = useState(false);
  const [DeviceData, setDeviceData] = useState(null);
  const [ProceedStatus, setProceedStatus] = useState(null);

  const [OpenConfirmationDialog, setOpenConfirmationDialog] = useState(false);

  const handleOpenConfirmationDialog = () => {
    setOpenConfirmationDialog(true);
  };

  useEffect(() => {
    if (!props.open) {
      setProceedStatus(null);
    }
  }, [props.open]);

  const handleCloseConfirmationDialog = () => {
    setOpenConfirmationDialog(false);
  };

  const handleAlertOpen = (message, type) => {
    setAlertType(type);
    setAlertMessage(message);
    setAlertOpen(true);
  };

  useEffect(() => {
    GetAllDevice(setIsLoading, setDeviceData, handleAlertOpen);
  }, []);

  useEffect(() => {
    if (!props.open) {
      setData({
        device_name: 'select',
        brand_name: 'select',
        modal_number: 'select',
        bank_name: 'select',
        remarks: ''
      });
      handleCloseConfirmationDialog();
    }
  }, [props.open]);

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleDataChange = (name, value) => {
    if (name === 'quantity' && /^[0-9]*$/.test(value)) {
      setData((prevData) => ({ ...prevData, [name]: value }));
    } else if (name !== 'quantity') {
      setData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  const handleSubmit = () => {
    if (Data.bank_name === 'select' || Data.bank_name === '') {
      handleAlertOpen('Please select the bank name', 'error');
    }
    else if (Data.device_name === 'select' || Data.brand_name === '') {
      handleAlertOpen('Please select a device name', 'error');
    } else if (Data.brand_name === 'select' || Data.brand_name === '') {
      handleAlertOpen('Please select a brand name', 'error');
    } else if (Data.modal_number === 'select' || Data.modal_number === '') {
      handleAlertOpen('Please select a modal number', 'error');
    } else if (Data.device_category === 'select' || Data.device_category === '') {
      handleAlertOpen('Please select a device category', 'error');
    } else if (!Data.quantity ||Data.quantity <1) {
      handleAlertOpen('Please enter a quantity', 'error');
    } else if (!Data.date) {
      handleAlertOpen('Please select a deadline', 'error');
    } else {
      handleOpenConfirmationDialog();
    }
  };

  const HandleProceed = (status) => {
    setProceedStatus(status);
    handleOpenConfirmationDialog();
  };

  const handlePostData = () => {
    if (!ProceedStatus) {
      PostPurchaseRequest(Data, setIsLoading, handleAlertOpen, props.handleClose);
    } else {
      props.handleProceed(ProceedStatus,Data.remarks);
    }
  };

  // console.log(DeviceData);

  return (
    <React.Fragment>
      <ConfirmationDialog
        IsLoading={IsLoading}
        data={Data}
        open={OpenConfirmationDialog}
        handleClose={handleCloseConfirmationDialog}
        handleDataChange={handleDataChange}
        handleSubmit={handlePostData}
      />
      <SnackBar message={AlertMessage} type={AlertType} open={AlertOpen} handleClose={handleAlertClose} />
      <Dialog
        open={props.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <Box sx={{ cursor: 'pointer', position: 'absolute', top: 5, right: 5, fontSize: '20px' }} onClick={props.handleClose}>
          <IoClose />
        </Box>
        <DialogTitle id="alert-dialog-title">
          <Typography variant="h3">Purchase Request</Typography>
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <table>
              <tr>
                <th style={{ textAlign: 'left' }}>
                  <Typography variant="h5">Bank Name</Typography>
                </th>
                <td></td>
                <td>
                  {props.type === 'create' ? (
                    <Box sx={{ minWidth: 120 }}>
                      <FormControl fullWidth size="small">
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          disabled={IsLoading}
                          value={Data.bank_name ? Data.bank_name : ''}
                          onChange={(e) => handleDataChange('bank_name', e.target.value)}
                        >
                          <MenuItem value={'select'} disabled>Select</MenuItem>
                          {DeviceData &&
                            [...new Map(DeviceData.filter((item)=>!item.status||item.status==="Active").map((item) => [item.bank_name, item])).values()]?.map((item, key) => (
                              <MenuItem key={key} value={item.bank_name}>
                                {item.bank_name}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Box>
                  ) : (
                    <Box sx={{ minWidth: 120 }}>
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        value={props.SelectedRow && props.SelectedRow.device_details ? props.SelectedRow.device_details.bank_name : ''}
                        disabled
                        // onChange={(e)=>handleDataChange("quantity",e.target.value)}
                        size="small"
                        fullWidth
                      />
                    </Box>
                  )}
                </td>
              </tr>
              <tr>
                <th style={{ textAlign: 'left' }}>
                  <Typography variant="h5">Device Name/ID</Typography>
                </th>
                <td></td>
                <td style={{ width: '70%' }}>
                  {props.type === 'create' ? (
                    <Box sx={{ minWidth: 120 }}>
                      <FormControl fullWidth size="small">
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          disabled={IsLoading}
                          value={Data.device_name ? Data.device_name : ''}
                          onChange={(e) => handleDataChange('device_name', e.target.value)}
                          fullWidth
                        >
                          <MenuItem value={'select'}>Select</MenuItem>
                          {DeviceData && Data.bank_name !== ''
                            ? [
                                ...new Map(
                                  DeviceData.filter((item) => item.bank_name === Data.bank_name&&(!item.status||item.status==="Active")).map((item) => [item.name, item])
                                ).values()
                              ].filter((item)=>!item.status||item.status==="Active").map((item, key) => (
                                <MenuItem key={key} value={item.name}>
                                  {item.name}
                                </MenuItem>
                              ))
                            : null}
                        </Select>
                      </FormControl>
                    </Box>
                  ) : (
                    <Box sx={{ minWidth: 120 }}>
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        value={props.SelectedRow && props.SelectedRow.device_details ? props.SelectedRow.device_details.name : ''}
                        disabled
                        // onChange={(e)=>handleDataChange("quantity",e.target.value)}
                        size="small"
                        fullWidth
                      />
                    </Box>
                  )}
                </td>
              </tr>
              <tr>
                <th style={{ textAlign: 'left' }}>
                  <Typography variant="h5">Brand Name</Typography>
                </th>
                <td></td>
                <td>
                  {props.type === 'create' ? (
                    <Box sx={{ minWidth: 120 }}>
                      <FormControl fullWidth size="small">
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          disabled={IsLoading}
                          value={Data.brand_name ? Data.brand_name : ''}
                          onChange={(e) => handleDataChange('brand_name', e.target.value)}
                        >
                          <MenuItem value={'select'}>Select</MenuItem>
                          {DeviceData && Data.device_name
                            ? [
                                ...new Map(
                                  DeviceData.filter((item) => item.bank_name === Data.bank_name && item.name === Data.device_name && (!item.status||item.status==="Active")).map(
                                    (item) => [item.brand_name, item]
                                  )
                                ).values()
                              ].filter((item)=>!item.status||item.status==="Active").map((item, key) => (
                                <MenuItem key={key} value={item.brand_name}>
                                  {item.brand_name}
                                </MenuItem>
                              ))
                            : null}
                        </Select>
                      </FormControl>
                    </Box>
                  ) : (
                    <Box sx={{ minWidth: 120 }}>
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        value={props.SelectedRow && props.SelectedRow.device_details ? props.SelectedRow.device_details.brand_name : ''}
                        disabled
                        // onChange={(e)=>handleDataChange("quantity",e.target.value)}
                        size="small"
                        fullWidth
                      />
                    </Box>
                  )}
                </td>
              </tr>
              <tr>
                <th style={{ textAlign: 'left' }}>
                  <Typography variant="h5">Modal Number</Typography>
                </th>
                <td></td>
                <td>
                  {props.type === 'create' ? (
                    <Box sx={{ minWidth: 120 }}>
                      <FormControl fullWidth size="small">
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          disabled={IsLoading}
                          value={Data.modal_number ? Data.modal_number : ''}
                          onChange={(e) => handleDataChange('modal_number', e.target.value)}
                        >
                          <MenuItem value={'select'}>Select</MenuItem>
                          {DeviceData && Data.device_name
                            ? DeviceData.filter(
                                (item) =>
                                  item.bank_name === Data.bank_name && item.name === Data.device_name && item.brand_name === Data.brand_name && (!item.status||item.status==="Active")
                              ).map((item, key) => (
                                <MenuItem key={key} value={item._id}>
                                  {item.model}
                                </MenuItem>
                              ))
                            : null}
                        </Select>
                      </FormControl>
                    </Box>
                  ) : (
                    <Box sx={{ minWidth: 120 }}>
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        value={props.SelectedRow && props.SelectedRow.device_details ? props.SelectedRow.device_details.model : ''}
                        disabled
                        // onChange={(e)=>handleDataChange("quantity",e.target.value)}
                        size="small"
                        fullWidth
                      />
                    </Box>
                  )}
                </td>
              </tr>

              <tr>
                <th style={{ textAlign: 'left' }}>
                  <Typography variant="h5">Quantity</Typography>
                </th>
                <td></td>
                <td>
                  {props.type === 'create' ? (
                    <Box sx={{ minWidth: 120 }}>
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        disabled={IsLoading}
                        value={Data.quantity ? Data.quantity : ''}
                        onChange={(e) => handleDataChange('quantity', e.target.value)}
                        size="small"
                        fullWidth
                      />
                    </Box>
                  ) : (
                    <Box sx={{ minWidth: 120 }}>
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        disabled={true}
                        value={props.SelectedRow ? props.SelectedRow.quantity : ''}
                        onChange={(e) => handleDataChange('quantity', e.target.value)}
                        size="small"
                        fullWidth
                      />
                    </Box>
                  )}
                </td>
              </tr>
              <tr>
                <th style={{ textAlign: 'left' }}>
                  <Typography variant="h5">Deadline of the purchase request</Typography>
                </th>
                <td></td>
                <td>
                  {props.type === 'create' ? (
                    <Box sx={{ minWidth: 120 }}>
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        disabled={IsLoading}
                        type="date"
                        onChange={(e) => handleDataChange('date', e.target.value)}
                        InputProps={{
                          inputProps: {
                            min: new Date().toISOString().split('T')[0]
                          }
                        }}
                        size="small"
                        fullWidth
                        onKeyDown={(e) => e.preventDefault()}
                      />
                    </Box>
                  ) : (
                    <Box sx={{ minWidth: 120 }}>
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        value={props.SelectedRow ? props.SelectedRow.deadline : ''}
                        disabled
                        // onChange={(e)=>handleDataChange("quantity",e.target.value)}
                        size="small"
                        fullWidth
                      />
                    </Box>
                  )}
                </td>
              </tr>
              {/* <tr>
                                <th style={{ textAlign: 'left' }}><Typography variant='h5'>Remarks</Typography></th>
                                <td></td>
                                <td>
                                    <Box sx={{ minWidth: 120 }}>
                                        <TextField
                                            id="outlined-basic"
                                            variant="outlined"
                                            disabled={IsLoading}
                                            type='text'
                                            onChange={(e) => handleDataChange("remarks", e.target.value)}
                                            InputProps={{
                                                min: new Date()
                                            }}
                                            size='small'
                                            fullWidth
                                        />
                                    </Box>
                                </td>
                            </tr> */}
            </table>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
          {props.type === 'create' ? (
            <Button disabled={IsLoading} color="secondary" variant="contained" onClick={handleSubmit}>
              {IsLoading ? 'LOADING...' : 'NEXT'}
            </Button>
          ) : props.filter === 'pending' &&(sessionStorage.getItem('UserType')==='cso'||props.UserRole==='checker')? (
            <Grid container justifyContent="center" gap={5}>
              <Grid item md={2} sm={12}>
                <Button disabled={IsLoading} fullWidth color="success" variant="contained" onClick={() => HandleProceed('approved')}>
                  APPROVE
                </Button>
              </Grid>
              <Grid item md={2} sm={12}>
                <Button fullWidth disabled={IsLoading} color="error" variant="contained" onClick={() => HandleProceed('rejected')}>
                  REJECT
                </Button>
              </Grid>
            </Grid>
          ) : null}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
